import { AccessDevice, Gateway, StationVirtualPoint } from "../type/stationType"
import MqttServer from "./mqttUtil"
import appConfig from "@/config"
import axios from "axios"

//  虚拟点实时值
export const getLabelData = async (
  points: (StationVirtualPoint & { label_name: string })[],
  access_device: AccessDevice[],
  gateway: Gateway[],
  mqttServe: MqttServer[]
) => {
  const results: { value: number; unit: string; property_code: string; label_name: string }[] = []
  for (let point of points) {
    let data = 0,
      calcData: any[] = JSON.parse(point.calc_data),
      calcFormula = point.calc_formula,
      configData: { device_id: number | string; property_code: string; value: number }[] = []
    if (!calcData || !calcData.length) {
      return []
    }
    // console.log(calcData)

    let tempArray: {
      gateway_id: number
      uuid: string
      mqtt_server_id: number
      datas: { device_id: number; defines: string[] }[]
    }[] = []
    calcData.map((calcd) => {
      configData.push({ device_id: calcd.device_id, property_code: calcd.property_code, value: 0 })
      const target1 = access_device.find((ad) => ad.device_id == calcd.device_id)
      if (target1) {
        const findTemp = tempArray.find((ta) => ta.gateway_id == target1.gateway_id)
        if (findTemp) {
          const findDevice = findTemp.datas.find((d) => d.device_id == target1.device_id)
          if (findDevice) {
            findDevice.defines.push(calcd.property_code)
          } else {
            findTemp.datas.push({ device_id: target1.device_id, defines: [calcd.property_code] })
          }
        } else {
          const temp: any = {}
          temp.gateway_id = target1.gateway_id
          const target2 = gateway.find((g) => g.gateway_id == target1.gateway_id)
          if (target2) {
            temp.uuid = target2.uuid
            temp.mqtt_server_id = target2.mqtt_server_id
            temp.datas = [{ device_id: target1.device_id, defines: [calcd.property_code] }]
            tempArray.push(temp)
          }
        }
      }
    })
    // console.log(tempArray)

    let promiseArr: Promise<any>[] = []
    tempArray.map((temp) => {
      promiseArr.push(
        new Promise((resolve, reject) => {
          let currentTime = new Date().getTime()
          mqttServe[temp.mqtt_server_id].request(
            `/gateway/${temp.uuid}`,
            { id: "get_group_property_" + currentTime, action: "get_group_property", data: temp.datas },
            (res: any) => {
              res = JSON.parse(res)
              if (res.id !== "get_group_property_" + currentTime || !res.code) {
                reject()
                return
              }
              let resData = res.data
              configData.forEach((configItem) => {
                let datas = resData.find((rdItem: any) => rdItem.device_id == configItem.device_id)?.datas || []
                if (datas && datas.length) {
                  configItem.value = parseFloat(
                    datas.find((dItem: any) => dItem.property_code === configItem.property_code)?.value || 0
                  )
                }
              })
              resolve(configData)
            },
            5000
          )
        })
      )
    })

    let res = await Promise.all(promiseArr)
    res.forEach((r) => {
      r.forEach((rs: { device_id: any; property_code: any; value: any }) => {
        calcFormula = calcFormula.replaceAll(`[${rs.device_id}_${rs.property_code}]`, rs.value)
      })
    })
    data += eval(calcFormula) || 0
    results.push({ value: data, unit: point.unit, label_name: point.label_name, property_code: point.property_code })
  }
  return results
}

//  虚拟点日月年值
export const calcVirtualData = async (point: StationVirtualPoint[], type: string, endTime?: Date) => {
  // console.log(point)
  let calcData: any[] = []
  let calcFormule = []
  let unit: string = ""
  if (point.length > 0) {
    for (let p of point) {
      unit = p.unit
      calcData = calcData.concat(JSON.parse(p.calc_data))
      calcFormule.push(p.calc_formula)
    }
    let deviceId = calcData.map((cd) => cd.device_id)
    deviceId = [...new Set(deviceId)]
    // console.log(deviceId)
    let deviceData = []
    for (let d of deviceId) {
      let property_code = calcData.filter((cdf) => cdf.device_id === d).map((cdm) => cdm.property_code)
      property_code = [...new Set(property_code)]
      deviceData.push({
        deviceId: d,
        defines: property_code,
        prefix: appConfig.prefix,
      })
    }
    let formData = new FormData()
    let nowTime = endTime ? endTime.getTime() : new Date().getTime()
    formData.append("data", JSON.stringify(deviceData))
    formData.append("time", nowTime.toString())
    formData.append("type", type)
    formData.append("token", "hadkjlvnouq8293015hf0d9sh")
    formData.append("zoneStr", Intl.DateTimeFormat().resolvedOptions().timeZone)
    // console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)
    let request: any = await axios
      .post(`${appConfig.hBaseUrl}demo/getGroupAccumulativeDataByZone`, formData)
      .then((data) => {
        return data
      })
      .catch((err) => {
        console.log("calcVirtualData err", err)
      })
    let resData = request.data.data
    // console.log(resData, nowTime)
    calcData.forEach((cd) => {
      let cdData = resData.find((rd: any) => Number(rd.deviceId) === Number(cd.device_id)).data[cd.property_code]
      cdData.shift()
      cdData.pop()
      cd.value = 0
      cdData.forEach((item: any) => {
        cd.value += item.value
      })
    })
    let data = 0
    for (let cf of calcFormule) {
      calcData.forEach((r) => {
        // console.log(cf, r);
        cf = cf.replaceAll(`[${r.device_id}_${r.property_code}]`, r.value)
        // console.log(cf);
      })
      data = Number(data) + eval(cf)
    }
    return { value: data.toFixed(2), unit }
  }
  return { value: 0, unit: "" }
}

//  按时间间隔取虚拟点 !!!point是单个的点!!!
export const calcVirtualByInterval = async (
  point: StationVirtualPoint,
  startTime: number,
  endTime: number,
  interval: string,
  fn: string = "sampling"
) => {
  const unit = point.unit
  const calcData = JSON.parse(point.calc_data)
  const calcFormula = point.calc_formula
  const data: any[] = []
  let intervalTime: number = 0
  let indexArray: number[] = []

  if (calcData && calcData.length > 0) {
    const body = []
    for (let cd of calcData) {
      body.push({ deviceId: cd.device_id, propertyCode: cd.property_code, fn })
    }
    try {
      // console.log(body)
      const res: any = await axios.post(
        `${appConfig.hBaseUrl}demo/getAggregateData?prefix=${appConfig.prefix}&start=${startTime}&end=${endTime}&tg=${interval}`,
        body
      )
      if (res.status !== 200 || Number(res.data.code) !== 200) {
        throw new Error("Server Error")
      }
      const resultData = res.data.data
      if (resultData.length == 0) {
        return { data, unit }
      }
      // console.log(resultData)

      if (interval === "5min") {
        intervalTime = 1000 * 60 * 5
      } else if (interval === "15min") {
        intervalTime = 1000 * 60 * 15
      } else if (interval === "30min") {
        intervalTime = 1000 * 60 * 30
      } else if (interval === "60min") {
        intervalTime = 1000 * 60 * 60
      }
      resultData.forEach((_: any, index: number) => {
        indexArray[index] = 0
      })
      const currentTime = new Date().getTime()
      endTime = currentTime < endTime ? currentTime : endTime
      for (let time = startTime; time < endTime; time += intervalTime) {
        let sum = 0,
          tempCalc = calcFormula
        resultData.forEach((item: any, index: number) => {
          var number = 0
          if (item.data[indexArray[index]] && item.data[indexArray[index]].t1 === time) {
            number = item.data[indexArray[index]].value
            indexArray[index]++
          }
          tempCalc = tempCalc.replaceAll(`[${item.deviceId}_${item.propertyCode}]`, number.toString())
        })
        sum += eval(tempCalc) || 0
        data.push({ value: sum, time: time + intervalTime })
      }
      return { data, unit }
    } catch (e) {
      console.log(e)
      throw e
    }
  } else {
    return { data: [], unit }
  }
}

/**
 * 虚拟点按日（24小时）、周（7天）、月（30天）、年（12月）、总（年）计算
 */
export const calcVirtualCumulantData = async (point: StationVirtualPoint[], type: string, time?: Date) => {
  let calcData: any[] = []
  let calcFormule = []
  let unit: string = ""
  if (point.length > 0) {
    for (let p of point) {
      unit = p.unit
      if (p.calc_data) {
        calcData = calcData.concat(JSON.parse(p.calc_data))
        calcFormule.push(p.calc_formula)
      }
    }
    // 获取calcData中的deviceId并去重
    let deviceId = calcData.map((cd) => cd?.device_id || 0)
    deviceId = [...new Set(deviceId)]
    // 整理后台请求格式
    let deviceData = []
    for (let d of deviceId) {
      let property_code = calcData.filter((cdf) => cdf.device_id === d).map((cdm) => cdm.property_code)

      property_code = [...new Set(property_code)]
      deviceData.push({
        deviceId: d,
        defines: property_code,
        prefix: appConfig.prefix,
      })
    }
    // console.log(deviceData);
    // let r = Math.random();
    // console.log(deviceData);
    // 创建form表单提交
    let formData = new FormData()
    formData.append("data", JSON.stringify(deviceData))
    formData.append("time", time ? time.getTime().toString() : new Date().getTime().toString())
    formData.append("type", type)
    formData.append("token", "hadkjlvnouq8293015hf0d9sh")
    formData.append("zoneStr", Intl.DateTimeFormat().resolvedOptions().timeZone)
    // console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)
    let request: any = await axios
      .post(`${appConfig.hBaseUrl}demo/getGroupAccumulativeDataByZone`, formData)
      .then((data) => {
        return data
      })
      .catch((err) => {
        console.log("calcVirtualCumulantData err", err)
      })
    let resData = request.data.data
    // console.log(request);
    calcData.forEach((cd) => {
      let cdData = resData.find((rd: any) => Number(rd.deviceId) === Number(cd.device_id)).data[cd.property_code]
      cdData.shift()
      cdData.pop()
      cd.data = cdData
    })

    let data = [],
      label = []
    const currentDate = new Date().getTime()
    for (let cd of calcData) {
      let cdData = cd.data
      label = cdData.filter((d: any) => d.startTime < currentDate).map((d: any) => d.startTime)
    }

    let sum = new Array(label.length).fill(0)
    for (let cF of calcFormule) {
      for (let i in sum) {
        let cf = cF
        calcData.forEach((r) => {
          cf = cf.replaceAll(`[${r.device_id}_${r.property_code}]`, r.data[i]?.value || 0)
        })
        sum[i] += eval(cf)
      }
    }
    data = sum.map((s) => s.toFixed(2))
    return { data, label, unit }
  }
  return { data: [], label: [], unit: "" }
}

//  设备点位
export const getDeviceData = (
  param: { device_id: number | string; defines: string[] }[],
  mqtt: MqttServer,
  uuid: string
) => {
  return new Promise((resolve, reject) => {
    let times = new Date().getTime()
    mqtt.request(
      `/gateway/${uuid}`,
      {
        id: "get_group_property_" + times,
        action: "get_group_property",
        data: param,
      },
      (res: any) => {
        resolve(JSON.parse(res))
      },
      1000
    )
  })
}
